/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useMixpanel } from 'react-mixpanel-browser';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { setMenuType } from 'modules/_shared/redux/menuActions';
import { getUserSocieties } from 'modules/society/redux/societyActions';

import menuTypes from 'constants/menuTypes';

import CustomDataTable from 'modules/_shared/components/Tables/CustomDataTable';
import TableLoader from 'modules/_shared/components/Tables/TableLoader';
import transformData from 'modules/_shared/components/Tables/helpers';

import { useTranslate } from 'hooks/useTranslate';
import { resetStateSociety } from 'modules/_shared/redux/resetActions';
import tableColumns from './tableColumns';

function AdministratedList({ items = 10 }) {
  const { t, i18n } = useTranslate();
  const dispatch = useDispatch();
  const mixpanel = useMixpanel();

  const user = useSelector((state) => state.user);
  const isDemo = useSelector((state) => state.society?.role?.isDemo);

  const [administratedData, setAdministratedData] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [isLoadingData, setIsLoadingData] = useState(true);
  const [currentTableColumns, setCurrentTableColumns] = useState(
    tableColumns(i18n)
  );

  useEffect(() => {
    if (user && user.societies.administrated?.length) {
      getUserSocieties(
        user['_id'],
        'admin',
        setAdministratedData,
        'table'
      ).then((result) => {
        if (!result?.length) {
          setIsLoadingData(false);
        }
      });
    } else {
      setIsLoadingData(false);
    }
  }, [user]);

  useEffect(() => {
    const newData = administratedData?.map((data) => ({
      society: data?.society,
      name: data?.society?.name,
      partners: data?.partnersCount,
      value: data?.societyValue,
      creationDate: data?.society?.creationDate || '',
      isAdmin: data?.isUserAdmin,
      isDemo,
      user,
      mixpanel,
    }));

    if (newData.length > 0) {
      setTableData(
        transformData({
          data: newData,
          columns: tableColumns(i18n),
        })
      );
    } else {
      setTableData([]);
    }
  }, [administratedData, i18n.language]);

  useEffect(() => {
    setCurrentTableColumns(tableColumns(i18n));
  }, [i18n.language]);

  useEffect(() => {
    setMenuType(menuTypes.MAIN);
    dispatch(resetStateSociety());
  }, []);

  return (
    <div className="nk-content-body">
      <div className="nk-content-wrap">
        <div className="nk-block-head nk-block-head-sm">
          <div className="nk-block-between">
            <div className="nk-block-head-content">
              <h3 className="nk-block-title page-title">
                {t('AdministratedTitle')}
              </h3>
              <div className="nk-block-des text-soft">
                <p>
                  {administratedData?.length === 0
                    ? t('AdministratedNoSocieties')
                    : t('AdministratedHaveSocieties', {
                        count: administratedData?.length,
                      })}
                </p>
              </div>
            </div>

            <div className="nk-block-head-content">
              <div className="toggle-wrap nk-block-tools-toggle">
                <div className="toggle-expand-content" data-content="pageMenu">
                  <ul className="nk-block-tools g-3">
                    <li>
                      <Link to="/diagrama-administradas">
                        <button type="button" className="btn btn-outline-light">
                          <em className="icon ni ni-network" />
                          <span className="d-none d-md-block">
                            {t('Chart')}
                          </span>
                        </button>
                      </Link>
                    </li>
                    <li>
                      <Link to="/cuadro-administradas">
                        <button type="button" className="btn btn-outline-light">
                          <em className="icon ni ni-menu-squared" />
                          <span className="d-none d-md-block">{t('View')}</span>
                        </button>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {administratedData.length > 0 ? (
          <CustomDataTable
            data={tableData}
            columns={currentTableColumns}
            searchBy={t('Society')}
            pagination
            className="nk-tb-list"
            rowsPerPage={items}
            actions
            showDense
          />
        ) : (
          isLoadingData && <TableLoader rows={items} />
        )}
      </div>
    </div>
  );
}

export default AdministratedList;
